import { render, staticRenderFns } from "./MailvelopeEditor.vue?vue&type=template&id=0f14fc25&scoped=true"
import script from "./MailvelopeEditor.vue?vue&type=script&lang=js"
export * from "./MailvelopeEditor.vue?vue&type=script&lang=js"
import style0 from "./MailvelopeEditor.vue?vue&type=style&index=0&id=0f14fc25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f14fc25",
  null
  
)

export default component.exports